import {loadTIME} from './cache'

// 判断是否是微信浏览器
export function IsWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

// 判断登录时间是否过期
export function TimeExpired() {
  if (loadTIME() === undefined || loadTIME() + 2592000000 < new Date().getTime()) {
    if (IsWeiXin()) {
      // 测试
      // window.location = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxae1d85bfd66812e6&redirect_uri=https%3A%2F%2Fynwx.zgwyzxw.cn%2Fhome&response_type=code&scope=snsapi_userinfo&state=89e0440c0f961acf72521cda57d897f0#wechat_redirect'
      // 中正正式
      window.location = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5effd0de8eaddf30&redirect_uri=https%3A%2F%2Fzzwx.yzptzx.cn%2Fhome&response_type=code&scope=snsapi_userinfo&state=89e0440c0f961acf72521cda57d897f0#wechat_redirect'
    } else {
      this.$router.push('/Login')
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/js/isWeixin.js